import { Outlet } from 'react-router-dom';

import { AuthLayout } from 'src/layouts/auth/auth-layout';

// ----------------------------------------------------------------------
// Dev-only. Wraps auth-flow prototypes (invite/register/login/reset screens)
// in the REAL AuthLayout — unlike PrototypeShell (a stand-in for dashboard
// chrome), AuthLayout has no auth/platform/subscription dependency, so the
// production component can be used directly with no fake copy.
// ----------------------------------------------------------------------

export function AuthPrototypeShell() {
  return (
    <AuthLayout>
      <Outlet />
    </AuthLayout>
  );
}
